<script setup lang="ts">
import BaseCard from "@/core/components/base/BaseCard.vue";
import {Switch} from "@/core/components/ui/switch";
import {computed, ref, watch} from "vue";
import {disruptionLogisticsApi} from "@/container";
import useEnvironment from "@/notification/composables/useEnvironment";
import LegacyAccess from "@/core/interfaces/Access";
import DeprecatedGrouping from "@/core/interfaces/laboratory/Grouping";

const props = defineProps<{ groupId: number | null, healthcenters: any[] }>();
const emits = defineEmits(['update-sharing']);
const {environment} = useEnvironment();

/**
 * Check if the current user has accepted sharing.
 */
const hasAcceptedSharing = computed(() => {
    if (!environment?.value?.entityId) {
        return true;
    }

    return props.healthcenters.findIndex(
        healthcenter => (environment.value as LegacyAccess).entityId === healthcenter.id
    ) !== -1;
});


const accepted = ref<boolean>(hasAcceptedSharing.value);

watch(() => props.healthcenters, () => {
    accepted.value = hasAcceptedSharing.value;
});

watch(accepted, (newValue) => {
    if (!environment.value?.entityId && !environment.value?.entity?.grouping?.id) {
        return;
    }

    disruptionLogisticsApi().updateSharing(
        (environment.value.entity.grouping as DeprecatedGrouping).id, environment.value.entityId, !!newValue
    )
        .then(() => emits('update-sharing'));
});
</script>

<template>
  <base-card v-if="groupId === 0" class="p-4">
    <h2>Groupe de partage de votre groupement</h2>
    <p>Ce groupe a pour but de partager les données entre chaque membre du groupement, vous pouvez changer votre
      autorisation de partage à tout moment</p>
    <div class="flex flex-row justify-between items-center gap-10 pt-4">
      <p v-if="hasAcceptedSharing">
        Partage activé avec les autres pharmacies membres du groupement
      </p>
      <p v-else>
        Vous avez refusé le partage de données avec les autres membres du groupement (vous n'apparaissez donc pas
        dans le listing, réactivez le partage pour apparaitre de nouveau)
      </p>
      <div class="flex flex-row items-center gap-4">
        <Label>{{ accepted ? "Activé" : "Désactivé" }}</Label>
        <Switch v-model="accepted" class="mr-4" />
      </div>
    </div>
  </base-card>
</template>
